module.exports = __webpack_public_path__ + "img/story-price.ad1b5477.png";